<template>
    <div class="container-fluid">
        <section class="content-header">
                <div class="row mb-2">
                    <h3>Panel RGPD</h3>
                </div>
        </section>
        <section class="content">
            <div class="card">
                <div class="card-header">
                    <ul class="nav nav-pills card-header-tabs">
                        <li class="nav-item">
                            <a href="#configuracion" class="nav-link active" data-toggle="tab">Configuración</a>
                        </li>
                        <li class="nav-item">
                            <a href="#eliminación" class="nav-link" data-toggle="tab">Eliminación de datos</a>
                        </li>
                        <li class="nav-item">
                            <a href="#registros" class="nav-link" data-toggle="tab">Registros de eliminación</a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content" style=" margin-top: 15px; padding-bottom: 15px;">
                        <div class="active tab-pane" id="configuracion">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Presupuestos/Albaranes/Facturas</h3>
                                        </div>
                                        <div class="card-body">
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon3">Días conservación</span>
                                                </div>
                                                <input v-model="configuracionFactura" type="number" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-sm btn-primary" @click="guardarValorFactura">Guardar</button>
                                        </div>
                                    </div>
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Parte de trabajo genérico</h3>
                                        </div>
                                        <div class="card-body">
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon3">Días conservación</span>
                                                </div>
                                                <input type="number" v-model="configuracionParte" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-sm btn-primary" @click="guardarValorParte">Guardar</button>
                                        </div>
                                    </div>
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Documentos personalizados</h3>
                                        </div>
                                        <div class="card-body">
                                            <div style="display: grid;">
                                                <div @click="console.log(documento)" v-for="documento in configuracionesPersonalizadas" style="margin-bottom: 0" :key="documento.id_documento" class="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Días conservación</span>
                                                    </div>
                                                    <input type="number" v-model="documento.valor" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon3">{{ documento.nombre }}</span>
                                                    </div>
                                                </div>                                                                                               
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-sm btn-primary" @click="guardarValoresPersonalizados">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="card card-light card-outline">
                                        <div class="card-header">
                                            <h3 class="card-title">Proceso de eliminación</h3>
                                        </div>
                                        <div class="card-body">
                                             <p >
                                                En la pestaña "Eliminación de datos" se realizará la búsqueda de los servicios que contiene los datos personales a eliminar.
                                            </p>
                                            <p >
                                                Proceso:
                                                <ul>
                                                    <li><strong>Datos personales</strong>: Se reemplazarán por el texto "***Eliminación_protección_datos***"</li>
                                                    <ul>
                                                        <li><strong>Datos reemplazados de asegurados y perjudicados:</strong> Nombre, Razón Social, Dirección, Teléfono 1 y descripción, Teléfono 2 y descripción, Teléfono 3 y descripción, Fax, Email, NIF, Número IBAN, Persona de contacto, Póliza</li>
                                                        <li><strong>Datos que permanecen:</strong> Código, Compañía seguro, Año del siniestro, Descripción, Observaciones, Nota importante, Población, Código Postal, Provincia, Coordenadas y Observaciones</li>
                                                    </ul>
                                                    <li><strong>Documentos adjuntados</strong>: Eliminación por completo de los documentos (fotos, vídeos...)</li>
                                                    <li><strong>Informes fotográficos</strong>: Eliminación por completo de los informes</li>
                                                    <li><strong>Llamadas</strong>: Eliminación por completo de las llamadas grabadas</li>
                                                    <li><strong>Partes de trabajo</strong>: Consultar siguiente apartado "Retención de documentos"</li>
                                                    <li><strong>Presupuestos, albaranes y facturas</strong>: Consultar siguiente apartado "Retención de documentos"</li>
                                                    <li><strong>Documentos personalizados</strong>: Consultar siguiente apartado "Retención de documentos"</li>
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card card-light card-outline">
                                        <div class="card-header">
                                            <h3 class="card-title">Proceso de eliminación</h3>
                                        </div>
                                        <div class="card-body">
                                             <p >
                                            Aún solicitándose la eliminación de los datos personales de los Servicios, 
                                            los documentos generados en el servicio pueden retenerse según el periodo de validez que se especifique en cada uno de ellos.
                                            </p>

                                            <p class="text-red">
                                                En el caso de que no se especifiquen días:
                                                    <ul>
                                                        <li class="text-red">Parte genérico: Se eliminarán los datos personales del parte</li>
                                                        <li class="text-red">Documentos personalizados: Se eliminarán los documentos por completo</li>
                                                        <li class="text-red">Factura, presupuestos y albaranes: Se eliminarán los datos personales del documento</li>
                                                    </ul>
                                            </p>

                                            <p >
                                                Una vez cumplido el plazo de retención de los documentos de los <u>Servicios que se han solicitado la eliminación de datos</u>
                                                <ul>
                                                    <li >Parte genérico: Se eliminarán los datos personales del parte</li>
                                                    <li >Documentos personalizados: Se eliminarán los documentos por completo</li>
                                                    <li >Factura, presupuestos y albaranes: Se eliminarán los datos personales del documento</li>
                                                </ul>
                                            </p>
                                            <p class="text-red">
                                                Todos los documentos adjuntados a la visita o al servicio (fotos, vídeos...) no forman parte de la retención de documentos, por lo que serán eliminados.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="eliminación">
                            <div class="row">
                                <div class="col-md-9">
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Buscador</h3>
                                        </div>
                                        <div class="card-body">
                                            <h4>Asegurado</h4>
                                            <div style="display: flex; justify-content: space-between; gap: 25px">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">DNI/NIE Asegurado</span>
                                                    </div>
                                                    <input v-model="dniEliminado" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">                                                
                                                </div>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Teléfono Asegurado</span>
                                                    </div>
                                                    <input v-model="telefonoEliminado" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">                                                
                                                </div>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Nombre Asegurado</span>
                                                    </div>
                                                    <input v-model="nombreEliminado" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">                                                
                                                </div>
                                            </div>
                                            <h4>Servicios eliminados o finalizados</h4>
                                            <div class="row" style="align-items: start;">
                                                <div class="col-md-6">
                                                    <div class="input-group mb-3">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon3">Empresa</span>
                                                        </div>
                                                        <select v-model="empresaEliminados" class="form-control" id="">
                                                            <option value="todas">Todas</option>
                                                            <option v-for="empresa in Object.values(empresasEliminados)" :key="empresa.id_empresa" :value="empresa">{{ empresa.nombre }} ({{ empresa.cif }})</option>
                                                        </select>
                                                    </div>
                                                    <div class="input-group mb-3">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon3">Compañias/Corr./AF</span>
                                                        </div>
                                                        <select v-model="companiaEliminados" class="form-control" id="">
                                                            <option value=""></option>
                                                            <option v-for="compania in companiasEliminados" :key="compania.idcompañia" :value="compania.idcompañia">{{ compania.nombre }} ({{ compania.prefijo }}) <span v-if="compania.estado_companyia == 'borrado'">[Eliminada]</span> </option>
                                                        </select>                                             
                                                    </div>
                                                </div>
                                                <div class="input-group mb-3 col-md-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Fecha inicio</span>
                                                    </div>
                                                    <input v-model="inicioEliminado" type="date" class="form-control" id="basic-url" aria-describedby="basic-addon3">                                                
                                                </div>
                                                <div class="input-group mb-3 col-md-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon3">Fecha fin</span>
                                                    </div>
                                                    <input v-model="finEliminado" type="date" class="form-control" id="basic-url" aria-describedby="basic-addon3">                                                
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-primary" @click="buscarEliminados">Buscar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="serviciosEliminar.length > 0">
                                <div class="col-md-9">
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Servicios (eliminados o finalizados) para eliminar datos personales</h3>
                                        </div>
                                        <div class="card-body">
                                            <div>
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Fecha
                                                            </th>
                                                            <th>
                                                                Código
                                                            </th>
                                                            <th>
                                                                Empresa
                                                            </th>
                                                            <th>
                                                                Estado
                                                            </th>
                                                            <th>
                                                                Asegurado/a
                                                            </th>
                                                            <th>
                                                                NIF/NIE/CIF
                                                            </th>
                                                            <th>

                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="servicio in serviciosEliminar" :key="servicio.idservicios">
                                                            <td>{{ servicio.fecha }}</td>
                                                            <td>{{ servicio.codigo }}</td>
                                                            <td>{{ servicio.datos_empresa.nombre }}</td>
                                                            <td>{{ servicio.estado }}</td>
                                                            <td>{{ servicio.nombre }}</td>
                                                            <td>{{ servicio.nif }}</td>
                                                            <td><input type="checkbox" v-model="servicio.seleccionado"></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="serviciosEliminar.length > 0">
                                <div class="col-md-9">
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Eliminación</h3>
                                        </div>
                                        <div class="card-body">
                                            <div style="display: flex; gap: 20px">
                                                <div class="form-group">
                                                    <label for="fechaSolicitud">Fecha Solicitud (*)</label>
                                                    <input v-model="fechaSolicitud" placeholder="Fecha" type="date" class="form-control" id="fechaSolicitud">
                                                </div>
                                                <div class="form-group">
                                                    <label for="nombreSoliciante">Nombre del/la solicitante (*)</label>
                                                    <input v-model="nombreSoliciante" placeholder="Nombres y apellidos" type="text" class="form-control" id="nombreSoliciante">
                                                </div>
                                                <div class="form-group">
                                                    <label for="idSoliciante">Identificación del/la solicitante (*)</label>
                                                    <input v-model="idSoliciante" placeholder="NIF/NIE/CIF/Pasaporte" type="text" class="form-control" id="idSoliciante">
                                                </div>
                                            </div>
                                            <div style="display: flex; gap: 20px">
                                                <div class="form-group">
                                                    <label for="nombreVerificacion">Verificación realizada por (*)</label>
                                                    <input v-model="nombreVerificacion" placeholder="Nombre persona responsable de protección de datos" type="text" class="form-control" id="nombreVerificacion">
                                                </div>
                                                <div class="form-group">
                                                    <label for="fechaVerificacion">Fecha Verificación (*)</label>
                                                    <input v-model="fechaVerificacion" placeholder="Fecha de verificación" type="date" class="form-control" id="fechaVerificacion">
                                                </div>
                                            </div>
                                            <div style="display: flex; gap: 20px">
                                                <div class="form-group">
                                                    <label for="nombreSoliciante">Razón de la solicitud (*)</label>
                                                    <textarea v-model="razonSolicitud" placeholder="Razón de la solicitud" type="text" class="form-control" id="razonSolicitud"></textarea>
                                                </div>
                                                <div class="form-group">
                                                    <label for="idSoliciante">Observaciones</label>
                                                    <textarea v-model="observaciones" placeholder="Observaciones" type="text" class="form-control" id="observaciones"></textarea>
                                                </div>
                                            </div>
                                            <button class="btn btn-danger" @click="generarEliminacion">Eliminar datos personales</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="registros">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="card card-light">
                                        <div class="card-header">
                                            <h3 class="card-title">Registros</h3>
                                        </div>
                                        <div class="card-body">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Fecha</th>
                                                        <th>Empresa</th>
                                                        <th>Realizado por</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="eliminadas in empresasEliminadas" :key="eliminadas.id_eliminacion">
                                                        <td>{{ eliminadas.fecha_texto }}</td>
                                                        <td>{{ eliminadas.datos.nombre_empresa }}</td>
                                                        <td>{{ eliminadas.datos.nombre_quien_elimina }} ({{ eliminadas.datos.usuario_quien_elimina }})</td>
                                                        <td><button @click="descargarPdf(eliminadas)" class="btn btn-sm"><i class="fas fa-file-pdf"></i></button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { PwgsApi } from '../../services/PwgsApi';
export default {
    components: {
    },
    data() {
        return {
            empresasEliminadas:'',
            razonSolicitud:'',
            observaciones:'',
            nombreVerificacion:'',
            fechaVerificacion:'',
            nombreSoliciante:'',
            idSoliciante:'',
            fechaSolicitud:'',
            serviciosEliminar:[],
            empresaEliminados:'todas',
            configuracionFactura:'',
            configuracionParte:'',
            configuracionesPersonalizadas:[],
            empresasEliminados:[],
            finEliminado:'',
            inicioEliminado:'',
            companiaEliminados:'',
            companiasEliminados:[],
            dniEliminado:'',
            telefonoEliminado:'',
            nombreEliminado:'',
            urlglobal:localStorage.getItem("direccion"),
        }
    },
    methods: {
        descargarPdf(eliminadas){
            if(this.urlglobal == 'null.pwgs.app'){
                this.urlglobal = 'pwgs.raul.pwgs5.interno.apuyen.app';
            }
            window.open('https://'+this.urlglobal+'/modulos/rgpd/pdf.php?id_eliminacion='+eliminadas.id_eliminacion, '_blank');
        },
        confirmarEliminacion(){
            this.$confirm.require({
                message: '¿Está seguro de eliminar los documentos y datos personales de los servicios seleccionados? Esta acción no es reversible.',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                this.generarEliminacion()
                },
                reject: () => {
                    return;
                }
            })
        },
        async generarEliminacion(){
            const api = new PwgsApi();
            var ids = [];
            this.serviciosEliminar.forEach(servicio => {
                if(servicio.seleccionado){
                    ids.push(servicio.idservicios);
                }
            })
            try{
                await api.post('pwgs-rgpd/1/eliminacion', {
                    ids: ids,
                    datos:{
                        nombre_empresa:this.empresaEliminados.nombre,
                        cif_empresa: this.empresaEliminados.cif,
                        direccion_empresa: this.empresaEliminados.direccion,
                        telefono_empresa: this.empresaEliminados.telefono,
                        email_empresa: this.empresaEliminados.email,
                        fecha_solicitud: this.fechaSolicitud,
                        nombre_solicitante: this.nombreSoliciante,
                        identificacion_solicitante: this.idSoliciante,
                        nombre_verificacion: this.nombreVerificacion,
                        fecha_verificacion: this.fechaVerificacion,
                        razon_solicitud: this.razonSolicitud,
                        observaciones: this.observaciones
                    }
                });
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Registro creado', life: 2000 });
                this.obtenerConfiguraciones();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: e, detail: e, life: 5000 });
            }
        },
        async buscarEliminados(){
            const api = new PwgsApi();
            if(this.empresaEliminados == 'todas'){
                alert('Debe seleccionar una empresa para poder eliminar.');
                return;
            }
            if(this.inicioEliminado == '' || this.finEliminado == ''){
                alert('Debe seleccionar las fechas de inicio y fin.');
                return;
            }
            this.serviciosEliminar = [];
            try{
                var servs = await api.post('pwgs-rgpd', {companyia_servicio: this.companiaEliminados, 
                    empresa_servicio: this.empresaEliminados.id_empresa, fecha_inicio_servicio: this.fechaesp(this.inicioEliminado), fecha_fin_servicio: this.fechaesp(this.finEliminado),
                    dni_asegurado: this.dniEliminado, telefono_asegurado: this.telefonoEliminado, nombre_asegurado: this.nombreEliminado});  
                
                servs.forEach(element => {
                    element.fecha = this.fechaesp(element.fecha);
                    element.seleccionado = true;
                })
                this.serviciosEliminar = servs;
            }catch(e){
                this.$toast.add({ severity: 'error', summary: e, detail: e, life: 5000 });
            }
        },
        async guardarValoresPersonalizados(){
            const api = new PwgsApi();
            try{
                console.log(this.configuracionesPersonalizadas);
                this.configuracionesPersonalizadas.forEach(async (element) => {
                    console.log('elemento',element)
                    await api.put('pwgs-rgpd/'+element.id_configuracion+'/personalizado', {valor: element.valor});
                })                
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Configuración guardada', life: 2000 });
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async obtenerConfiguraciones(){
            const api = new PwgsApi();
            var configuraciones = await api.get('pwgs-rgpd');
            this.configuracionFactura = configuraciones.factura.valor_configuracion;
            this.configuracionParte = configuraciones.parte.valor_configuracion;
            this.configuracionesPersonalizadas = configuraciones.personalizados;
            this.empresasEliminados = configuraciones.empresas;
            this.companiasEliminados = configuraciones.companias;
            this.empresasEliminadas = configuraciones.eliminaciones;
        },
        async guardarValorFactura(){
            const api = new PwgsApi();
            try{
                await api.put('pwgs-rgpd', {tipo: 'factura',valor: this.configuracionFactura});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Configuración guardada', life: 2000 });
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async guardarValorParte(){
            const api = new PwgsApi();
            try{
                await api.put('pwgs-rgpd', {tipo: 'parte',valor: this.configuracionParte});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Configuración guardada', life: 2000 });
            }catch(error){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        fechaesp(fecha) {
            const [año, mes, dia] = fecha.split("-");
            return `${dia}/${mes}/${año}`;
        },
    },
    mounted() {
        this.obtenerConfiguraciones();
    },
    watch: {
    }
}
</script>
<style>
</style>